import { Component, Inject } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { IConfirmDialogConfig } from '@app/infrastructure/models/dialog';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { SaveCancelButtonConfig } from '@app/infrastructure/models/form/button';
import { StudentCoinService } from '@app/infrastructure/core/services/api/student-coin.service';

@Component({
  templateUrl: './gacha-dialog.component.html',
  styleUrls: ['./gacha-dialog.component.scss'],
})
export class GachaDialogComponent {
  public AVATAR_COST: number = 20;
  buttonConfig: SaveCancelButtonConfig = new SaveCancelButtonConfig({
    save: 'Yes, buy now!',
    cancel: 'Cancel',
    hasCustomCancel: true,
  });
  constructor(
    @Inject(MAT_DIALOG_DATA) public dialog: IConfirmDialogConfig,
    private dialogRef: MatDialogRef<ConfirmDialogComponent>,
    private coinService: StudentCoinService,
  ) {}
  public get submitDisabled(): boolean {
    return this.coinService.coinPurse < this.AVATAR_COST;
  }
  public submit(): void {
    this.dialogRef.close(true);
  }
}
